<template>
	<div>
		<div ref="appPromotionModal" id="app-promotion-modal" class="component app-promotion uk-modal-container uk-flex-top" uk-modal>
			<div class="uk-modal-dialog uk-margin-auto-vertical">
				<button class="uk-modal-close-default" type="button" uk-close @click="closeModal"></button>
				<div class="uk-modal-header">
					<h2 class="uk-modal-title">{{ title }}</h2>
				</div>
				<div class="uk-modal-body">
					<p v-html="text"></p>
					<div class="uk-text-right">
						<button class="uk-button uk-button-default uk-margin-small-right" @click="closeModal">Nope</button>
						<a v-if="isAndroid && androidStoreUrl" :href="androidStoreUrl" class="uk-button uk-button-primary">Download</a>
						<a v-else-if="isiOS && iosStoreUrl" :href="iosStoreUrl" class="uk-button uk-button-primary">Download</a>
						<a class="uk-button uk-button-primary" href="/app" v-else>download</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
	name: 'AppPromotionModal',
	props: {
		expireDays: {
			type: Number,
			default: 7
		},
		delay: {
			type: Number,
			default: 5000
		},
		androidStoreUrl: {
			type: String,
			required: false
		},
		iosStoreUrl: {
			type: String,
			required: false
		},
		title: {
			type: String,
			default: 'Download de app'
		},
		text: {
			type: String,
			default: 'Download onze app en blijf op de hoogte van alle nieuwste updates!'
		},
	},
	data() {
		return {
			showModalFlag: false,
			isModalSuppressed: false,
		};
	},
	computed: {
		isAndroid() {
			return /android/i.test(navigator.userAgent);
		},
		isiOS() {
			return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		},
	},
	methods: {
		attemptToShowModal() {
			if (!this.isModalSuppressed) {
				this.showModal();
			}
		},
		showModal() {
			this.$logger('app/components/app-promotion/showModal');
			this.showModalFlag = true;
			UIkit.modal(document.getElementById('app-promotion-modal')).show();
		},
		closeModal() {
			this.$logger('app/components/app-promotion/close');
			this.showModalFlag = false;
			UIkit.modal(document.getElementById('app-promotion-modal')).hide();
			this.setModalSuppressedCookie();
		},
		setModalSuppressedCookie() {
			this.$logger('app/components/app-promotion/setModalSuppressedCookie');
			Cookies.set('appPromotion', 'true', { expires: 7 });
			this.isModalSuppressed = true;
		},
		checkModalSuppression() {
			this.isModalSuppressed = Cookies.get('appPromotion') === 'true';
		}
	},
	mounted() {
		this.$logger('app/components/app-promotion/mounted');
		this.checkModalSuppression();		
		setTimeout(this.attemptToShowModal, this.delay); // 5 seconds after page load
	}
};
</script>

<style scoped>
/* Add your styles here */
</style>
